import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Swords, Sparkles, Crown, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { card, label, btnPrimary } from "@/lib/styles";

export default function InterviewStart() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [starting, setStarting] = useState(false);

  useEffect(() => { api.get("/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);

  const startInterview = async () => {
    setStarting(true);
    try {
      const { data } = await api.post("/interview/start", {});
      navigate(`/interview/${data.session_id}`);
    } catch (e) {
      if (e.response?.status === 402) {
        toast.error("Free trial used up. Upgrade to Pro");
        navigate("/pricing");
      } else {
        toast.error(e.response?.data?.detail || "Could not start interview");
      }
    } finally { setStarting(false); }
  };

  const isPro = d?.plan === "pro";

  return (
    <div className="min-h-screen">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <span className={label}>the arena</span>
        <h1 className="mt-2 text-3xl sm:text-4xl font-black tracking-tight">Face Altaris</h1>
        <p className="mt-4 text-zinc-400 leading-relaxed">
          One question at a time, drawn at random from across the whole curriculum, real interview
          loops at Google, Meta, Amazon and the top AI labs. You answer free-form. Altaris holds the
          rubric until you're graded.
        </p>

        <div className={`${card} p-8 mt-10`}>
          {d && (
            <p className="text-sm text-zinc-500 mb-6">
              {isPro
                ? "Pro · unlimited interviews"
                : `${Math.max(d.trial_limit - d.trial_interviews_used, 0)} free interview(s) left`}
            </p>
          )}
          <button data-testid="start-random-interview-btn" onClick={startInterview} disabled={starting} className={`${btnPrimary} mx-auto`}>
            {!isPro && <Crown size={16} />} <Swords size={16} /> {starting ? "summoning Altaris..." : "Start mock interview"}
          </button>
          {d && !isPro && d.trial_interviews_used >= d.trial_limit && (
            <Link to="/pricing" className="mt-4 flex items-center justify-center gap-1.5 text-sm text-yellow-400 hover:underline">
              <Sparkles size={14} /> Upgrade for unlimited interviews <ArrowRight size={14} />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
